import { MatMenuTrigger } from '@angular/material/menu';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    HostListener,
    Input,
    OnInit,
    ViewChild,
} from '@angular/core';
import { debounce } from 'rxjs/operators';
import { Subject, timer } from 'rxjs';

import { EntityItem } from '@main/models';

@Component({
    selector: 'multiline-entities-list',
    templateUrl: './multiline-entities-list.component.html',
    styleUrls: ['./multiline-entities-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultilineEntitiesListComponent implements AfterViewInit, OnInit {
    @Input() parent: HTMLElement;
    @Input() entities: EntityItem[] = [];

    @HostBinding('class.no-animation')
    @Input()
    noAnimation = false;

    @ViewChild(MatMenuTrigger) othersPopup: MatMenuTrigger;

    private elementContent: HTMLElement;
    private resize$ = new Subject<void>();
    private checkInterval: NodeJS.Timer;

    showedEntities: EntityItem[] = [];
    hiddenItems: EntityItem[] = [];

    @HostListener('window:resize')
    onResize(): void {
        this.resize$.next();
    }

    @HostBinding('class.visible')
    visible = false;

    constructor(private cdr: ChangeDetectorRef, private elementRef: ElementRef) {}

    ngOnInit() {
        this.checkInterval = setInterval(() => {
            if (this.elementRef.nativeElement.clientHeight) {
                this.process();
            }
        }, 100);

        this.showedEntities = [...this.entities];

        this.resize$.pipe(debounce(() => timer(500))).subscribe(() => {
            this.process();
        });

        const conf = { childList: true };
        const contentMutationObserver = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    this.resize$.next();
                }
            });
        });

        contentMutationObserver.observe(this.elementRef.nativeElement, conf);
    }

    ngAfterViewInit(): void {
        this.elementContent = this.elementRef.nativeElement;

        setTimeout(() => {
            this.process();
        });
    }

    process(): void {
        if (this.parent.clientHeight < this.elementContent.clientHeight) {
            this.hiddenItems = [this.showedEntities.pop(), ...this.hiddenItems];
        } else if (this.elementContent.clientHeight) {
            this.visible = true;
            clearInterval(this.checkInterval);
        }

        this.cdr.markForCheck();
    }
}
